<template>
  <div id="app">
    <!-- Main Site Navbar -->
    <b-navbar :sticky="true" v-if="!$store.state.user.loggedIn" toggleable="lg">
      <b-navbar-brand href="/" class="d-flex align-items-center">
        <img src="@/assets/img/logo.png" class="img-fluid logo" />
      </b-navbar-brand>
      <b-navbar-toggle target="nav_collapse" />
      <b-collapse is-nav id="nav_collapse">
        <b-navbar-nav class="ml-auto">
          <b-nav-item to="/" class="d-flex align-items-center">Home</b-nav-item>
          <b-nav-item-dropdown text="Products" class="d-flex align-items-center">
            <b-dropdown-item to="/products/cars">Cars</b-dropdown-item>
            <b-dropdown-item to="/products/electronics">Electronics</b-dropdown-item>
            <b-dropdown-item to="/products/engines?type=diesel">Engines -> Diesel</b-dropdown-item>
            <b-dropdown-item to="/products/engines?type=gas">Engines -> Gas</b-dropdown-item>
            <b-dropdown-item to="/products/engines?type=glow">Engines -> Glow</b-dropdown-item>
            <b-dropdown-item to="/products/helicopters">Helicopters</b-dropdown-item>
            <b-dropdown-item to="/products/kits">Kits</b-dropdown-item>
            <b-dropdown-item to="/products/planes">Planes</b-dropdown-item>
            <b-dropdown-item to="/products/spares">Spares</b-dropdown-item>
            <b-dropdown-item to="/products/steam">Steam</b-dropdown-item>
            <b-dropdown-item to="/products/tools">Tools</b-dropdown-item>
            <b-dropdown-item to="/products/trains">Trains</b-dropdown-item>
          </b-nav-item-dropdown>
          <!-- <b-nav-item-dropdown text="My Stuff">
            <b-dropdown-item href="#">Antiques</b-dropdown-item>
            <b-dropdown-item href="#">Engines -> Diesel</b-dropdown-item>
            <b-dropdown-item href="#">Engines -> Gas</b-dropdown-item>
            <b-dropdown-item href="#">Engines -> Glow</b-dropdown-item>
            <b-dropdown-item href="#"></b-dropdown-item>
          </b-nav-item-dropdown>-->
          <b-nav-item to="/about" class="d-flex align-items-center">About</b-nav-item>
          <b-nav-item to="/contact" class="d-flex align-items-center">Contact</b-nav-item>
          <CartBadge />
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>

    <!-- Admin Navbar -->
    <b-navbar v-else toggleable="lg">
        <b-navbar-brand href="/" class="d-flex align-items-center">
        <img src="@/assets/img/logo.png" class="img-fluid logo" />
      </b-navbar-brand>
      <b-navbar-toggle target="nav_collapse" />
      <b-collapse is-nav id="nav_collapse">
        <b-navbar-nav class="ml-auto">
          <b-nav-item to="/admin/products">Product List</b-nav-item>
          <b-nav-item to="/admin/create-product">Add Product</b-nav-item>
          <b-nav-item to="/admin/orders">Orders</b-nav-item>
          <b-nav-item to="/admin/media-library">Media Library</b-nav-item>
          <b-nav-item v-on:click="logout">Logout</b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <router-view />
    <div class="footer-container">
      <div class="container section-padding">
        <div class="row">
          <div class="col-lg-4 d-flex align-items-center footer-spacing-ipad">
            <div>
              <img src="@/assets/img/footer-logo.png" class="footer-icon img-fluid space-bottom" />
              <h3 class="white space-bottom">
                Frank's Hangar - Estates & Consignments
              </h3>
              <p class="white">
                Estates and Consignment services since 2005, serving southern Ontario.
              </p>

            </div>
          </div>
          <div class="col-lg-3 offset-lg-1  footer-spacing-ipad">
            <div>
              <h3 class="white space-bottom">
                Quick Links
              </h3>
              <router-link class="footer-link" to="/">
                <p class="white no-bottom">
                  Home >
                </p>
              </router-link>
              <router-link class="footer-link" to="/products/planes">
                <p class="white no-bottom">
                  Planes >
                </p>
              </router-link>
              <router-link class="footer-link" to="/products/trains">
                <p class="white no-bottom">
                  Trains >
                </p>
              </router-link>
              <router-link class="footer-link" to="/products/cars">
                <p class="white no-bottom">
                  Cars >
                </p>
              </router-link>
              <router-link class="footer-link" to="/about">
                <p class="white no-bottom">
                  About >
                </p>
              </router-link>
              <router-link class="footer-link" to="/contact">
                <p class="white no-bottom">
                  Contact >
                </p>
              </router-link>
            </div>
          </div>
          <div class="col-lg-4">
            <div>
              <h3 class="white space-bottom">
                Contact Info
              </h3>
              <p class="white no-bottom-ipad">
                <strong>
                  Address:
                </strong>
                Tillsonburg Ontario, Canada
              </p>
              <!-- <p class="white no-bottom-ipad">
                <strong>
                  Phone Number:
                </strong>
                (613)-345-6547
              </p> -->
              <p class="white no-bottom-ipad">
                <strong>
                 Hours:
                </strong>
                Mon - Fri 9am - 5pm
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="row footer-lower">
          <div class="col-lg-12 d-flex justify-content-between">
            <div>
              <p class="white lower-footer-text no-bottom">
                Copyright © 2020 Frank's Hangar
              </p>
            </div>
            <div>
              <p class="white lower-footer-text no-bottom">
                Wesbite by <a href="https://www.bitbrownie.com">BitBrownie</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
</style>

<script>
  import { Auth } from "aws-amplify";
  import CartBadge from "@/components/CartBadge.vue";

  export default {
    components: {
      CartBadge,
    },
    methods: {
      logout() {
        Auth.signOut(); //Will handle nav in main.js
      },
    },
  };
</script>